import { Grid, Paper, Typography } from "@material-ui/core"
import { SelectGeneric } from "../../../atomic/atoms/Select"
import { useEffect, useRef, useState } from "react"
import TableGeneric from "../../../compartidos/abms/TableGeneric"
import { useSelector } from "react-redux"
import moment from "moment"
import { ButtonGeneric } from "../../../atomic/atoms/Buttons"
import { useTotemBasic } from "../../../../hooks/useCases/useTotemBasic"
import { GenericModal } from "../../../atomic/organisms/GenericModal"

const opcionesBandeja = [
    {
        value: 0,
        label: "Pendientes"
    },
    {
        value: 1,
        label: "Confirmadas"
    }
]

export const BandejaTotemBasic = () => {

    const [estadoSolicitudes, setEstadoSolicitudes] = useState(opcionesBandeja.find(x => x.label === "Pendientes").value)
    const [opcion, setOpcion] = useState("TODAS")
    const { solicitudes, opciones, boxesTomados } = useSelector(state => state.totemBasic)
    const [modal, setModal] = useState({ open: false, item: null })
    const { get, update } = useTotemBasic()
    const { idUsuario } = useSelector((state) => state.auth);

    // FILTRO PARA OPCIONES DEL BOX DEL USUARIO
    const boxUsuario = boxesTomados.find(box => box.horaLiberado === null && box.idUsuario === idUsuario)
    const opcionesUsuario = boxUsuario?.box?.opcionesPorBoxes.map(opcion => opcion.idOpcion)
    const opcionesFiltradas = opciones.filter(opcion => !boxUsuario || opcionesUsuario.includes(opcion.id))

    // BUSQUEDA CADA X CANTIDAD DE SEGUNDOS
    const intervalRef = useRef(null);
    useEffect(() => {
        get.solicitudes();
        intervalRef.current = setInterval(() => {
            get.solicitudes();
        }, 15000);
        return () => {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        };
    }, []);
    
    return (
        <>
            <Grid container justify="center">
                <Grid item xs={8} component={Paper} style={{ padding: 15 }}>
                    <Grid container>
                        <Grid item xs={3} style={{ marginLeft: 20, marginBottom: 10 }}>
                            <SelectGeneric
                                variant="outlined"
                                label="Estado"
                                name="estadoSolicitudes"
                                value={estadoSolicitudes}
                                onChange={(e) => setEstadoSolicitudes(e.target.value)}
                                menuItems={opcionesBandeja}
                            />
                        </Grid>
                        <Grid item xs={3} style={{ marginLeft: 20, marginBottom: 10 }}>
                            <SelectGeneric
                                variant="outlined"
                                label="Opcion"
                                name="opcion"
                                value={opcion}
                                onChange={(e) => setOpcion(e.target.value)}
                                menuItems={[{ value: "TODAS", label: "TODAS" }, ...opcionesFiltradas.map(opcion => ({ value: opcion.id, label: opcion.descripcion }))]}
                            />
                        </Grid>
                    </Grid>
                    <Grid item >
                        <TableGeneric
                            data={solicitudes.filter(solicitud => (estadoSolicitudes === opcionesBandeja.find(x => x.label === "Pendientes").value
                                ? !solicitud.idUsuario
                                : solicitud.idUsuario
                            ) &&
                                (opcion !== "TODAS" ? solicitud.idOpcion === opcion : true)
                            )}
                            align="center"
                            columns={[
                                {
                                    label: "Solicitud N°",
                                    id: "ticket"
                                },
                                {
                                    label: "Fecha - Hora",
                                    customBody: (item) => moment(item.fechaHora).format("DD/MM/YYYY - HH:mm")
                                },
                                {
                                    id: "opcion.descripcion",
                                    label: "Opción"
                                },
                                {
                                    customBody: (item) => item.subOpcion?.descripcion ?? "-",
                                    label: "Sub Opción"
                                },
                                ...(estadoSolicitudes === opcionesBandeja.find(x => x.label === "Confirmadas").value
                                    ? [
                                        {
                                            label: "Fecha Confirmación",
                                            customBody: (item) => item.fechaConfirmacion ? moment(item.fechaConfirmacion).format("DD/MM/YYYY - HH:mm") : "-"
                                        },
                                        {
                                            id: "usuario.userName",
                                            label: "Usuario Confirmación"
                                        },
                                        {
                                            label: "Liberar",
                                            customBody: (item) => (
                                                <ButtonGeneric
                                                    type="button"
                                                    text="LIBERAR"
                                                    onClick={() => {
                                                        setModal({ open: true, value: item, accion: "liberar" })
                                                    }}
                                                />
                                            )
                                        }
                                    ] : [
                                        {
                                            label: "Tomar",
                                            customBody: (item) => (
                                                <ButtonGeneric
                                                    type="button"
                                                    text="CONFIRMAR"
                                                    onClick={() => {
                                                        setModal({ open: true, value: item, accion: "confirmar" })
                                                    }}
                                                />
                                            )
                                        }
                                    ]
                                )
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <GenericModal
                open={modal.open}
                handleClose={() => setModal({ ...modal, open: false })}
                textButton="ACEPTAR"
                gridStyle={{ textAlign: "center" }}
                maxWidth="sm"
                handleButton={() => {
                    modal.accion === "confirmar" ?
                        update.tomarSolicitud({ idSolicitud: modal.value.id }) :
                        update.liberarSolicitud({ idSolicitud: modal.value.id })
                    setModal({ ...modal, open: false });
                }}
                title={
                    <Typography variant='h6'>
                        {`SOLICITUD N° ${modal.value?.id} - ${ modal.value?.subOpcion ? modal.value?.subOpcion.descripcion :modal.value?.opcion?.descripcion}`}
                    </Typography>
                }
            >
                <Typography variant='button' style={{ fontSize: "1.1em" }}>
                    {`¿Desea ${modal.accion} esta solicitud?`}
                </Typography>
            </GenericModal>
        </>
    )
}
